export const PROJECT_TYPE = {
  NORMAL: 'normal',
  COMPANY: 'company',
}
